import { useState, createContext, useContext, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import CONFIG from './config';
import { io } from 'socket.io-client';
import { SessionKeys } from './AppUtils';
import { setLiveBlink, setNotificationBlink } from '../redux/home/actions';
import useLogin from '../custom-hooks/useLogin';

const WebhookContext = createContext(null)

export const WebhookProvider = ({children}) => {

  // const dispatch = useDispatch();
  // const {isLoggedIn} = useLogin()
  // const [socket, setSocket] = useState();
  // const [liveInterval, setLiveInterval] = useState('')
  // const [notiInterval, setNotiInterval] = useState('')

  // useEffect(() => {
  //   setSocket(
  //     io(CONFIG.ROLEPLAY_SOCKET_URL, {
  //       cors: {
  //         origin: "*",
  //       },
  //     })
  //   );
  //   return () => {
  //     liveInterval && liveInterval.clearInterval()
  //     notiInterval && notiInterval.clearInterval()
  //     socket.off('send-live-session')
  //     socket.off('send-notification-activity')
  //     socket.disconnect();
  //     setSocket('')
  //   }
  // }, [dispatch])

  // useEffect(() => {
  //   if (socket) {
  //     socket.emit('check-live-session', {
  //       token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
  //     }, (response) => {
  //       console.log('LIVE SESSION', response)
  //     })
  //     setLiveInterval(setInterval(() => {
  //       socket.emit('check-live-session', {
  //         token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
  //       }, (response) => {
  //         console.log('LIVE SESSION', response)
  //       })
  //     }, 60000))

  //     socket.on('send-live-session', (response) => {
  //       console.log('LIVE SESSION', response, response.token)
  //       if (response.token && localStorage.getItem(SessionKeys.API_TOKEN_BROKER)) {
  //         if (response.token == localStorage.getItem(SessionKeys.API_TOKEN_BROKER)) {
  //           console.log('is Live', response.live)
  //           dispatch(setLiveBlink(response.live))
  //         }
  //       } else {
  //         console.log('Res', response)
  //         dispatch(setLiveBlink(response.live))
  //       }
  //     })
  //   }
  // }, [socket])

  // useEffect(() => {
  //   if (isLoggedIn && socket) {
  //     // alert('check notification')
  //     setNotiInterval(setInterval(() => {
  //       socket.emit('check-notification', {
  //       token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
  //     }, (response) => {})}, 60000))

  //     socket.on('send-notification-activity', (response) => {
  //       if (response.token && localStorage.getItem(SessionKeys.API_TOKEN_BROKER)) {
  //         if (response.token == localStorage.getItem(SessionKeys.API_TOKEN_BROKER)) {
  //           console.log('is notification', response.blink)
  //           dispatch(setNotificationBlink(response.blink))
  //         } else {
  //           dispatch(setNotificationBlink(response.blink))
  //         }
  //       } else {
  //         dispatch(setNotificationBlink(response.blink))
  //       }
  //     })
  //   }
  // }, [socket, isLoggedIn])



  return (
    <WebhookContext.Provider value={{}}>
      {children}
    </WebhookContext.Provider>
  )
}
